import React, { ChangeEvent, Component, MouseEvent, type JSX } from 'react';

interface ComponentProps {
  subjects: string[];
  selected?: string[];
}

interface ComponentState {
  open: boolean;
  selected: string[];
}

/**
 * There is also a jquery version of this component
 * the react component is used for examentraining
 * the jquery version is a fallback and is used by codelab.
 */
export class Subjects extends Component<ComponentProps, ComponentState> {

  /**
   * The placeholder when there are no subjects selected.
   */
  public initialPlaceholder: string = 'Kies vakken...';

  /**
   * Close the dropdown when clicking outside.
   */
  public $closeTrigger = $('body:not(".rich-dropdown"), .rich-dropdown__container');

  constructor(props: ComponentProps) {
    super(props);

    this.state = {
      open: false,
      selected: this.props.selected || [],
    };

    // bind events
    this.$closeTrigger.on('click',
      () => this.setState({ open: false })
    );
  }

  /**
   * Toggle the subject dropdown.
   */
  public toggleDropdown(e: MouseEvent<HTMLDivElement>): void {
    e.stopPropagation();
    this.setState({ open: !this.state.open });
  }

  /**
   * Add or remove item from selected array.
   */
  public onToggleSubject(e: ChangeEvent<HTMLInputElement>): void {
    const subject = e.currentTarget.value;
    const selected = this.state.selected;

    if (selected && selected.includes(subject)) {
      selected.splice(selected.indexOf(subject), 1);
    } else {
      selected.push(subject);
    }

    this.setState({
      selected: selected,
    });
  }

  /**
     * Returns the selected subjects into the placeholder
     */
  public getPlaceholder(): string {
    const { subjects } = this.props;
    const { selected } = this.state;

    // only display selected which are available in the provided list of subjects
    // when switching from Latijn VWO to VMBO, latijn should not be displayed
    const displaySelected = selected.filter(subject => subjects.includes(subject));

    let newPlaceholder = '';
    let placeholder = '';

    if (displaySelected && displaySelected.length > 0) {
      displaySelected.map((subject) => {
        newPlaceholder += (subject + ', ');
      });
    }

    if (newPlaceholder.length > 0) {
      // remove trailing comma
      placeholder = newPlaceholder.substr(0, newPlaceholder.length - 2);
    } else {
      placeholder = this.initialPlaceholder;
    }
    return placeholder;
  }

  public render(): JSX.Element {
    const { subjects } = this.props;
    const { selected } = this.state;
    const placeholder = this.getPlaceholder();

    const subjectList = (
      subjects.map((subject, key) => {
        let checked ='';

        if ( Array.isArray(selected) === true && selected.indexOf(subject) !== -1){
          checked = 'checked';
        }

        return (
          <div key={key + subject} className="p-relative">
            <input type="checkbox"
              id={subject}
              name="subject[]"
              value={subject}
              defaultChecked={!!checked}
              onChange={(e: ChangeEvent<HTMLInputElement>): void => this.onToggleSubject(e)}
            />
            <label className="pretty-checkbox" htmlFor={subject}>
              {subject}
            </label>
          </div>
        );
      })
    );

    let cssClass = 'front-search__form-field rich-dropdown';

    if (this.state.open) {
      cssClass += ' open';
    }

    return (
      <div className={cssClass}>
        <div className="rich-dropdown__placeholder rich-dropdown__placeholder--ext placeholder"
          onClick={(e: MouseEvent<HTMLDivElement>): void => this.toggleDropdown(e)}>
          { placeholder }
        </div>
        <div className="rich-dropdown__container"
          onClick={(e: MouseEvent<HTMLDivElement>): void => e.stopPropagation()}>
          {subjectList}
        </div>
      </div>
    );
  }
}
